// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__nrUuN"};